





































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { WidgetModel } from '@/_models/WidgetModel'

import { searchMissingNumber } from '@/_helpers'
import { FEATURES_OPTIONS_WIDGET } from '@/_consts/WidgetDefault'
import { EWidgetType, FeatureWidget } from '@/_enums/widget_setting'
import FloorModel from '@/_models/FloorModel'

@Component({
  components: {},
})
export default class UpsertWidgetSetting extends Vue {
  @Prop() formData!: WidgetModel

  form: WidgetModel = {
    width: '1/2',
    height: '1/2',
    order: 1,
    feature: FeatureWidget.user_search,
    options: {},
  }

  featuresSelect = FeatureWidget
  featureOptions = FEATURES_OPTIONS_WIDGET
  userFeaturesAutoComplete = {}

  isNew: boolean = false

  get currentUser() {
    return this.$store.state.authentication?.currentUser
  }

  get buttonSaveText(): any {
    return this.isNew ? this.$t('button.add') : this.$t('button.save')
  }

  get widgetSettingsData(): WidgetModel[] {
    return this.$store.state.settings.widgets
  }

  get floors(): FloorModel[] {
    const floors = [...this.$store.state.floors.all.items]
    if (this.form.feature === FeatureWidget.outdoor) {
      floors.unshift({
        _id: 'all',
        name: this.$t('all') as string,
      })
    }

    return floors
  }

  get orderInArr(): number[] {
    return Array.from(new Set(this.widgetSettingsData.map((item) => item.order as number).sort()))
  }

  handleApplyChange() {
    const pathAction = this.isNew ? 'settings/addOneWidget' : 'settings/updateOneWidget'
    this.$store
      .dispatch(pathAction, {
        ...this.form,
        order: +this.form.order,
        type: EWidgetType.user_setting,
        user_id: this.currentUser._id,
      })
      .then(() => {
        this.$emit('close')
      })
  }

  onSelectFeature(value?: string) {
    const featureSelected = value || (this.form.feature as string)
    const featureOptions = FEATURES_OPTIONS_WIDGET[featureSelected]
    // Reset option
    this.form.options = {}

    for (const optionKey of Object.keys(featureOptions)) {
      switch (featureOptions[optionKey].type) {
        case 'select':
          // @ts-ignore
          this.form.options[optionKey] = featureOptions[optionKey].options[0]
          break

        case 'select-floor':
          // @ts-ignore
          this.form.options[optionKey] = this.floors[0]._id
          break

        case 'select-filter':
          // @ts-ignore
          this.form.options[optionKey] = {
            selected: featureOptions[optionKey].options[0],
            value: '',
          }
          break

        default:
          // @ts-ignore
          this.form.options[optionKey] = featureOptions[optionKey].value
          break
      }
    }
  }

  calcOrderItemNew() {
    const orderCalc = searchMissingNumber(this.orderInArr)
    if (orderCalc) {
      this.form.order = orderCalc
    } else {
      const lagestOrder = this.orderInArr[this.orderInArr.length - 1]
      this.form.order = lagestOrder + 1
    }
  }

  created() {
    if (this.formData) {
      this.form = { ...this.formData }
    } else {
      this.onSelectFeature()
      this.isNew = true
    }

    if (this.widgetSettingsData.length && !this.formData) {
      this.calcOrderItemNew()
    }
  }
}
